import React, { FC, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ObservationVisibilityResponse } from 'src/front/api/generated';

import Application from 'src/front/components/Application';

import { StepperRefProps } from 'src/front/components/StepperView';
import CardObservationProvider from 'src/front/contexts/CardObservationContext';
import CardObservationActivation from './CardObservationActivation';
import CardObservationSearch from './CardObservationSearch';

export interface CardInfo {
  customerNumber: string;
  cardNumber: string;
  cardStatus: string;
}

const CardObservation: FC = () => {
  const { t } = useTranslation();
  const stepperRef = useRef<StepperRefProps>(null);

  const [cardInfo, setCardInfo] = useState<ObservationVisibilityResponse>();
  const [isCompleted, setIsCompleted] = useState<boolean>(false);

  const goToNextStep = (params: ObservationVisibilityResponse): void => {
    setCardInfo(params);
    stepperRef.current?.goToNextStep();
  };

  const goToPreviousStep = (): void => {
    stepperRef.current?.goToPreviousStep();
  };

  const steps = [
    {
      component: () => <CardObservationSearch goToNextStep={goToNextStep} />,
    },
    ...(cardInfo
      ? [
          {
            component: () => (
              <CardObservationActivation
                cardInfo={cardInfo}
                goToPreviousStep={goToPreviousStep}
                setIsCompleted={setIsCompleted}
              />
            ),
          },
        ]
      : []),
  ];

  const stepsVertical = useMemo(() => {
    return [
      {
        index: 1,
        text: t('cardObservation_stepper_cardSearch_text'),
      },
      {
        index: 2,
        text: t('cardObservation_stepper_cardActivation_text'),
      },
    ];
  }, [t]);

  return (
    <CardObservationProvider>
      <Application
        isCompleted={isCompleted}
        stepperRef={stepperRef}
        steps={steps}
        stepsVertical={stepsVertical}
      />
    </CardObservationProvider>
  );
};

export default CardObservation;
